

export enum CountryCodeAlpha2 {
  US = "us",
  CA = "ca"
}

export enum CountryCodeAlpha3 {
  USA = "USA"
}